<template>
  <div class="stop_popup" v-show="stopingVisible">
    <h1>数据回采</h1>
    <img :src="close" alt="关闭" @click="stopingCloseClick()" />
    <div class="overflow-x">
      <div class="stop_title">
        <span>
          数据回采即公众号历史文章采集，可以根据用户指定的公众号或者文章锁定目标，对该公众号的历史文章进行采集。
        </span>
        <a href="#">查看示例》</a>
        <span>什么是数据回采</span>
      </div>
      <div class="stop_top">数据回采</div>
      <!-- 监控公众号 -->
      <div class="stoping_number">
        <span>回采公众号</span>
        <div>
          <label>
            <input type="checkbox" />
            <span>通过文章地址</span>
          </label>
          <label>
            <input type="checkbox" />
            <span>我的收藏夹</span>
          </label>
        </div>
        <div class="stoping_cont">回采公众号内容</div>
      </div>
      <!-- 采集时间段 -->
      <div class="stoping_time">
        <span>采集时间段（数据采集时间区间为6个月（180天））</span>
      </div>
      <!-- 采集位置 -->
      <div class="stoping_position">
        <span class="stoping_position_title">采集位置</span>
        <span class="stoping_position_label">
          <label>
            <input type="checkbox" />
            <span>全部</span>
          </label>
          <label v-for="(acq, index) in acquisitionLocation" :key="index">
            <input type="checkbox" />
            <span>{{ acq }}</span>
          </label>
        </span>
      </div>
      <!-- 底部 -->
      <span class="stoping_info">
        <span
          >本次采集需消耗<span style="color: red">{{ 3 }}</span
          >次采集次数</span
        ><br />
        <span
          >本月剩余<span style="color: #21a0ff">{{ 2 }}</span
          >次采集次数</span
        >
      </span>
      <!-- button 提交 -->
      <span class="stoping_bottom">开始采集</span>
    </div>
  </div>
</template>

<script>
// import monitorPopup from '@/components/searchPopup/monitor-popup.vue'
export default {
  name: "stopPopup",
  data() {
    return {
      close: require("@/common/assets/close.png"),
      acquisitionLocation: [
        "头条",
        "二条",
        "三条",
        "四条",
        "五条",
        "六条",
        "七条",
        "八条",
      ],
    };
  },
  props: {
    stopingVisible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    stopingCloseClick() {
      // this.monitorVisible = !this.monitorVisible
      this.$emit("stopingCloseClick");
    },
  },
};
</script>

<style lang="less" scoped>
.stop_popup {
  width: 1200px;
  height: 1020px;
  background-color: #fff;
  position: fixed;
  margin-left: calc(100% / 2 - 1200px / 2);
  margin-top: 60px;
  z-index: 1100;
}
.stop_popup > h1 {
  width: 100%;
  height: 70px;
  box-sizing: border-box;
  // border: solid 1px #f1f1f1;
  border-top: none;
  border-left: none;
  border-right: none;
  font-size: 26px;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 600;
  line-height: 70px;
  text-align: center;
  color: #000000;
}
.stop_popup > img {
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
}
.overflow-x {
  // border: solid 1px;
  width: 100%;
  box-sizing: border-box;
  height: 88%;
  overflow-x: hidden;
  .stop_title::after {
    content: "";
    clear: both;
    display: block;
  }
  .stop_title {
    padding: 0 20px;
    width: 100%;
    // border: solid 1px green;
    color: #999999;
    box-sizing: border-box;
    font-size: 16px;
    span:first-child {
      float: left;
    }
    a:nth-child(2) {
      float: left;
      margin-left: 20px;
    }
    span:last-child {
      float: right;
    }
  }
  .stop_top {
    width: 100%;
    height: 60px;
    background-color: #fafafa;
    margin-top: 20px;
    line-height: 60px;
    text-align: left;
    font-weight: 600;
    font-size: 20px;
    text-indent: 1.2em;
  }
  .stoping_number {
    // float: left;
    width: 100%;
    box-sizing: border-box;
    // border: solid 1px red;
    // height: 60px;
    .stoping_cont {
      width: 100%;
    //   border: solid 1px;
      box-sizing: border-box;
      padding: 0 20px;
      margin-top: 20px;
    }
    span:first-child {
      font-size: 18px;
      margin-top: 20px;
      font-weight: 600;
      width: 100%;
      // border: solid 1px;
      display: block;
      padding: 0 20px;
      box-sizing: border-box;
    }
    div:nth-child(2)::after {
      content: "";
      clear: both;
      display: block;
    }
    div:nth-child(2) {
      width: 100%;
      // border: solid 1px;
      padding: 0 20px;
      margin-top: 6px;
      label {
        float: left;
        height: 30px;
        margin-left: 30px;
        input {
          float: left;
          width: 16px;
          height: 16px;
          display: inline-block;
          margin-top: calc(30px / 2 - 16px / 2);
        }
        span {
          float: left;
          font-size: 16px;
          line-height: 31px;
        }
      }
    }
  }
  .stoping_time {
    // border: solid 1px blue;
    width: 100%;
    padding: 0 20px;
    font-weight: 600;
    font-size: 20px;
    margin-top: 30px;
  }
  .stoping_position {
    // border: solid 1px;
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    // font-weight: 600;
    margin-top: 30px;
    .stoping_position_title {
      font-weight: 600;
      width: 100%;
      // border: solid 1px blueviolet;
      display: block;
    }
    .stoping_position_label {
      // border: solid 1px blue;
      display: block;
      width: 100%;
      margin-top: 10px;
      height: 30px;
      label {
        input {
          width: 16px;
          height: 16px;
          display: inline-block;
          margin-left: 36px;
          margin-top: calc(30px / 2 - 16px / 2);
          float: left;
        }
        span {
          float: left;
          font-size: 16px;
          line-height: 32px;
        }
      }
    }
  }
  .stoping_info {
    width: 100%;
    // border: solid 1px;
    display: block;
    margin-top: 30px;
    box-sizing: border-box;
    // height: 30px;
    padding: 4px 20px;
    font-size: 18px;
    letter-spacing: 1px;
  }
  .stoping_bottom {
    cursor: pointer;
    width: 337px;
    height: 45px;
    background: #21a0ff;
    border-radius: 5px;
    display: inline-block;
    margin-top: 50px;
    color: #fff;
    font-size: 20px;
    text-align: center;
    line-height: 45px;
    margin-left: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/searchPopup/stoping-popup.vue